import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CentralConfigService } from '@core/services/central-config.service';
import { environment } from '@env/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { JipLogoComponent } from '@shared/components/jip-logo/jip-logo.component';
import { OrganizationLogoComponent } from '@shared/components/molecules/organization-logo/organization-logo.component';
import { SharedIconComponent } from '@shared/components/shared-icon/shared-icon.component';
import { ToggleButtonSliderComponent } from '@shared/components/toggle-slider/toggle-button-slider/toggle-button-slider.component';
import { ToBoolean } from '@shared/decorators/to-boolean';
import { LogoDisplayOption } from '@shared/models/logo-type.model';

@Component({
  selector: 'app-cookies-settings',
  templateUrl: './cookies-settings.component.html',
  imports: [
    CommonModule,
    JipLogoComponent,
    OrganizationLogoComponent,
    SharedIconComponent,
    TranslateModule,
    ToggleButtonSliderComponent,
  ],
})
export class CookiesSettingsComponent {
  constructor(
    public activeModal: NgbActiveModal,
    public centralConfig: CentralConfigService
  ) {}
  @Input() logoDisplayOption: LogoDisplayOption;

  @Input() globalOrgId: string; // Central config

  @Input() @ToBoolean() hidePoweredBy: boolean; // Central config

  @Input() poweredByLogo: 'bbv' | 'jointcreate' | 'none';

  isActiveStrictlyCookies = true;

  bbvHomePageUrl = environment.bbvHomePageUrl;

  saveSettings(): void {
    this.activeModal.close({ strictlyCookies: this.isActiveStrictlyCookies });
  }
}
